/** Sélecteur de vidéos démo (bibliothèque vidéo / Bunny) pour une séance d'entraînement. */
import { useEffect, useMemo, useState } from "react";
import { Search, Video, X, Plus } from "lucide-react";
import { api } from "../lib/api";

export default function VideoPicker({ value = [], onChange, discipline = "" }) {
  const [all, setAll] = useState([]);
  const [q, setQ] = useState("");
  const [onlyDisc, setOnlyDisc] = useState(true);
  useEffect(() => { api.get("/training/admin/video-options").then((r) => setAll(r.data.videos || [])).catch(() => {}); }, []);

  const discWord = useMemo(() => {
    const d = (discipline || "").toLowerCase();
    if (d.includes("kick") || d.includes("muay")) return ["kick", "muay"];
    if (d.includes("bjj") || d.includes("bres") || d.includes("brés")) return ["brésilien", "bresilien", "bjj"];
    if (d.includes("jujutsu") || d.includes("can")) return ["can ryu", "can-ryu", "japonais", "autodéfense"];
    return [];
  }, [discipline]);

  const selected = value.map((id) => all.find((v) => v.id === id) || { id, title: id, missing: true });
  const results = all.filter((v) => !value.includes(v.id))
    .filter((v) => !q || (v.title || "").toLowerCase().includes(q.toLowerCase()))
    .filter((v) => !onlyDisc || !discWord.length || discWord.some((w) => (v.discipline || "").toLowerCase().includes(w)))
    .slice(0, 40);

  return (
    <div data-testid="video-picker" className="space-y-2">
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-1.5" data-testid="video-picker-selected">
          {selected.map((v) => (
            <span key={v.id} className={`inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full border ${v.missing ? "border-rose-700 text-rose-300" : "border-amber-600/60 bg-amber-600/10 text-amber-200"}`}>
              <Video className="w-3 h-3" /> {v.title}{v.belt_level ? ` · ${v.belt_level}` : ""}
              <button type="button" onClick={() => onChange(value.filter((x) => x !== v.id))} data-testid={`video-picker-remove-${v.id}`} className="hover:text-white"><X className="w-3 h-3" /></button>
            </span>
          ))}
        </div>
      )}
      <div className="flex gap-2 items-center">
        <div className="relative flex-1">
          <Search className="w-3.5 h-3.5 absolute left-2 top-2.5 text-zinc-500" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher une vidéo de la bibliothèque…" data-testid="video-picker-search"
            className="w-full bg-zinc-800 border border-zinc-700 rounded-lg pl-7 pr-3 py-2 text-sm text-zinc-100" />
        </div>
        {discWord.length > 0 && (
          <label className="text-[11px] text-zinc-400 flex items-center gap-1 cursor-pointer whitespace-nowrap">
            <input type="checkbox" checked={onlyDisc} onChange={(e) => setOnlyDisc(e.target.checked)} data-testid="video-picker-only-disc" /> Même discipline
          </label>
        )}
      </div>
      <div className="max-h-44 overflow-y-auto border border-zinc-800 rounded-lg divide-y divide-zinc-800" data-testid="video-picker-results">
        {results.length === 0 && <div className="text-xs text-zinc-500 p-3">Aucune vidéo trouvée. Importe-les d'abord dans « Vidéos techniques » (Bunny).</div>}
        {results.map((v) => (
          <button type="button" key={v.id} onClick={() => onChange([...value, v.id])} data-testid={`video-picker-add-${v.id}`}
            className="w-full flex items-center gap-2 px-3 py-2 text-left hover:bg-zinc-800 text-sm">
            {v.thumbnail_url ? <img src={v.thumbnail_url} alt="" className="w-12 h-7 object-cover rounded" /> : <div className="w-12 h-7 rounded bg-zinc-800 flex items-center justify-center"><Video className="w-3.5 h-3.5 text-zinc-500" /></div>}
            <span className="flex-1 truncate text-zinc-200">{v.title}</span>
            <span className="text-[10px] text-zinc-500 whitespace-nowrap">{v.discipline}{v.belt_level ? ` · ${v.belt_level}` : ""}{v.published === false ? " · brouillon" : ""}</span>
            <Plus className="w-4 h-4 text-amber-400" />
          </button>
        ))}
      </div>
    </div>
  );
}
